export const COMPLAINTS_TRANSLATE = {
    complaints: {
        breadcrumbName: "Complaints",
        new: { breadcrumbName: "New" },
        womanChannel: { breadcrumbName: "Women's Channel" },
        messages: {
            loadingMessage: "Please wait, analyzing file security…",
            conclude: "Complaint analysis completed successfully",
            sendToAnalysis: "Complaint analysis initiated",
            enableMessageFromComplainant: "Complainant comments enabled successfully",
            disableMessageFromComplainant: "Complainant comments disabled successfully",
            notFound: "Complaint not found",
            chooseCategory: "Complaint classified successfully"
        },
        params: {
            you: "You",
            complainant: "Complainant",
            committees: "Analysis Committee"
        },

        create: {
            confirmDialog: {
                title: "Attention!",
                body: 'Do you want to confirm the submission of this complaint?',
                back: {
                    text: "Close",
                },
                save: {
                    text: "Yes, confirm"
                }
            },
            helpDialog: {
                title: "Need help?"
            }
        },

        afterCreate: {
            title: "Your complaint has been submitted",
            imageAlt: "Ethics channel logo",
            message: "This is your protocol number. Write it down and keep it in a safe place, as it is the only way to track your complaint."
        },

        noResults: {
            label: "There are no comments on this complaint yet"
        },
        list: {
            table: {
                columns: {
                    protocolNumber: "Protocol",
                    category: "Category",
                    createdAt: "Created At",
                    status: "Status",
                    id: "ID",
                }
            },
            filters: {
                fields: {
                    protocolNumber: {
                        label: "Protocol No.",
                        placeholder: "Enter the protocol number",
                        url: "protocol-number"
                    },
                    category: {
                        label: "Category",
                        placeholder: "Select the category",
                        url: "category"
                    },
                    complaintType: {
                        label: "Channel",
                        placeholder: "Select the channel",
                        url: "channel"
                    },
                    status: {
                        label: "Status",
                        placeholder: "Select the status",
                        url: "status"
                    },
                }
            }
        },

        confirmAction: {
            title: "Attention!",
            message: 'Do you want to confirm sending the comment "{{message}}"? This comment will be visible to the complainant and cannot be changed.',
            alternativeMessage: "Do you want to confirm sending the comment \"{{message}}\"? This comment will NOT be visible to the complainant and CANNOT be changed.",
            complainantMessage: "Do you want to confirm sending the comment \"{{message}}\"? This comment CANNOT be deleted after submission",
            back: {
                text: "Close",
            },
            save: {
                text: "Yes, confirm"
            }
        },

        actions: {
            new: {
                text: "File a Complaint"
            },
            womanChannel: {
                text: "Women's Channel"
            },
            choiceHelpDialog: {
                text: "Not sure which to choose?"
            },
            followUpComplaints: {
                text: "Track my complaint"
            },
            enableComplainantToAnswer: {
                text: "Allow complainant comments"
            },
            disableComplainantToAnswer: {
                text: "Block complainant comments"
            },
            exportPdf: {
                text: "Export PDF"
            },
            help: {
                text: "Help"
            }
        },
        tabs: {
            general: "General",
            asks: "Additional Information"
        },
        save: {
            form: {
                actions: {
                    save: {
                        text: "Submit Complaint"
                    }
                },
                fields: {
                    attachments: {
                        label: "Attachments",
                        noResults: {
                            label: "You haven't added any attachments yet",
                            description: "",
                            action: {
                                label: "Add attachment"
                            }
                        }
                    },
                    categoryId: {
                        label: "Complaint Type",
                        placeholder: "Select the complaint type"
                    },
                    description: {
                        label: "Describe your complaint",
                        placeholder: ""
                    },
                    text: {
                        label: "Comment",
                        placeholder: ""
                    },
                    visibleForComplaint: {
                        label: "Visible to complainant",
                        tooltip: "This comment will be visible to the complainant when checking the complaint"
                    }
                }
            }
        },

        single: {
            breadcrumbName: "Track",
            confirmActions: {
                sendToAnalysis: {
                    title: "Attention!",
                    body: 'Do you want to start handling the complaint with protocol {{protocol}}?',
                    back: {
                        text: "Close",
                    },
                    save: {
                        text: "Yes, confirm"
                    }
                },

                conclude: {
                    title: "Attention!",
                    body: 'Do you want to conclude the handling of the complaint with protocol {{protocol}}?',
                    back: {
                        text: "Close",
                    },
                    save: {
                        text: "Yes, confirm"
                    }
                },
                allowComplainant: {
                    title: "Attention!",
                    body: 'Do you want to allow the complainant to send comments?',
                    back: {
                        text: "Close",
                    },
                    save: {
                        text: "Yes, confirm"
                    }
                },
                disableComplainant: {
                    title: "Attention!",
                    body: 'Do you want to disable the complainant from sending comments?',
                    back: {
                        text: "Close",
                    },
                    save: {
                        text: "Yes, confirm"
                    }
                },

                chooseCategory: {
                    title: "Attention!",
                }
            },
            fields: {
                description: "Description",
                protocolNumber: "Protocol Number",
                createdAt: "Created At",
                category: "Category",
                status: "Complaint Status",
                attachments: "Attachments"
            },
            actions: {
                conclude: {
                    text: "Conclude",
                },
                start: {
                    text: "Start"
                },
                exportPdf: {
                    text: "Export PDF"
                },
                chooseCategory: {
                    text: "Classify"
                }
            }
        },
        followUp: {
            breadcrumbName: "Track",
            title: "Enter the protocol number to track your complaint",
            form: {
                fields: {
                    protocol: {
                        label: "Protocol Number",
                        placeholder: "Enter the protocol number here"
                    }
                }
            }
        },
        investigationSteps: {
            noResults: {
                label: "There are no comments on this complaint yet"
            },
            params: {
                visibleForComplainant: "Visible to complainant"
            }
        },
        choiceHelpDialog: {
            title: "Which should I choose?"
        },
        asks: {
            params: {
                answer: "A:"
            }
        },
        exportComplaints: {
            title: "Export",
            subtitle: "Choose below whether you want to export with or without answers:",
            options: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                1: "With answers",
                // eslint-disable-next-line @typescript-eslint/naming-convention
                2: "Without answers",
            },
            save: {
                text: "Export"
            },
            back: {
                text: "Back"
            },
        },
    }
}
